// Groups that have multiple layers
export const ISO_LAYER_GROUP = 'ISO Market Points';
export const ISO_FORECASTING_SUBREGIONS_GROUP = 'Ascend ISO Forecasting Subregions';

// If we have multiple layers in the group we need to provide a way to find them by title
export const allISO = ['CAISO', 'CAISO w/ EIM', 'ERCOT', 'ISO-NE', 'MISO', 'NYISO', 'PJM', 'SPP'];

export const allISOSubregions = [
    'CAISO Subregions',
    'ERCOT Subregions',
    'ISO-NE Subregions',
    'MISO Subregions',
    'NYISO Subregions',
    'PJM Subregions',
    'SPP Subregions',
];

/** 
    This is used to group and display layers in the Features Sidebar Layers tab
    to allow user to select or unselect a layer to be visible or hidden in the map view. 
    Some layers are stand alone and are not under any group. 
    powerSimmCustomLayer.layerOrder = -1 is hardcoded to be displayed as the first layer in Features Sidebar Layers tab. 
    Note: this is not used to actually order layers to be shown the map view itself.  
*/
export const getLayerFeaturesSidebarOrder = (title) => {
    const featuresSidebarDisplayOrderArr = [ISO_LAYER_GROUP, ISO_FORECASTING_SUBREGIONS_GROUP];

    const order = featuresSidebarDisplayOrderArr.findIndex((elem) => title?.toUpperCase().includes(elem.toUpperCase()));
    return order > -1 ? order : 100;
};

export const AUTOCREATE_BASIS_ACTION_ID = 'autocreate-basis';

export const LAYERS_GROUPS = [
    {
        id: 'iso_node',
        layerOrder: getLayerFeaturesSidebarOrder(ISO_LAYER_GROUP),
        childrenNodes: [],
        title: ISO_LAYER_GROUP,
        fakeNode: true,
        minScale: 0,
        maxScale: 0,
        url: '',
        visible: true,
    },
    {
        id: 'forecasting_subregions_node',
        layerOrder: getLayerFeaturesSidebarOrder(ISO_FORECASTING_SUBREGIONS_GROUP),
        childrenNodes: [],
        title: ISO_FORECASTING_SUBREGIONS_GROUP,
        fakeNode: true,
        minScale: 0,
        maxScale: 0,
        url: '',
        visible: false,
    },
];
